<template>
  <form @submit.prevent="search">
    <div class="form-group">
      <slot name="label" />
      <div class="input-group mb-3">
        <input
          ref="searchInput"
          class="form-control form-control-lg pr-10"
          :id="inputId"
          :placeholder="$t('report.searchCompanyByCode')"
        />
        <div class="input-group-append" v-if="withIcon">
          <button class="input-group-text icon-search d-none d-md-block" />
        </div>
      </div>
    </div>
    <button class="btn btn-default btn-block" :class="buttonClass">
      {{ $t('search') }}
    </button>
    <slot />
  </form>
</template>

<script>
export default {
  props: {
    inputId: String,
    withIcon: { type: Boolean, default: true },
    buttonClass: { type: String, default: 'btn-md d-lg-none d-xl-none mt-3' },
  },
  data: () => ({
    url: import.meta.env.VITE_SEARCH_COMPANY_URL,
  }),
  methods: {
    search() {
      const url = this.url.replace('{query}', this.$refs.searchInput.value);
      const win = window.open(url, '_blank');

      if (win.focus) {
        win.focus();
      }
    },
  },
};
</script>
